module.exports = __webpack_public_path__ + "img/icon_lottery_no.90e562a2.png";